<script>
  import { _ } from "svelte-i18n"
  import { modals, user, user_storefronts, storefront_id_to_edit, user_subscription, can_upgrade_from_pro_to_business, business_subscription_deactivated } from '../stores'
  import OpenBuyModalButton from '../components/OpenBuyModalButton.svelte'
  import Insert from '../elements/Insert.svelte'
  import Button from '../elements/Button.svelte'
  import EmptyStateFooterList from './EmptyStateFooterList.svelte'
  import BusinessUpsellNotice from '../components/BusinessUpsellNotice.svelte'
  
  function openSubscribeModal() {
    modals.open('buy')
    if (typeof window.gtag == "undefined") return
    gtag('event', 'buy_modal_shown', {
      'initiator': 'uploaded_fonts_empty_state'
    });
  }

  function openNewStorefrontModal() {
    $storefront_id_to_edit = null
    modals.open('editStorefront')
  }
</script>

<div class="StorefrontsEmptyState">
  {#if $user === undefined}
    <Insert insert_position="before_previews" persistent={true}>
      <span slot="toptitle">
        BUSINESS PLAN FEATURE: STOREFRONTS
      </span>
      <span slot="title">
        Create custom font collections<br>
        to share with your clients!
      </span>
      <span slot="text">
        Share a simple font preview page with your selected fonts. 
        Help your customers make confident decisions by seeing their text in your fonts.
        <small>
          Storefronts are available in Wordmark Business along with the Uploaded Fonts feature.
        </small>
      </span>
      <span slot="button">
        <OpenBuyModalButton feature='storefronts'>Subscribe to <b>Wordmark Business</b></OpenBuyModalButton>
      </span>
    </Insert>
    <EmptyStateFooterList classList="ml-1">
      <li><small>Create multiple storefronts for different products or projects</small></li>
      <li><small>Add your storefront link to your checkout page or share it directly</small></li>
      <li><small><a href="/help/storefronts/" target="_blank">Learn more about storefronts</a> in our help pages</small></li>
    </EmptyStateFooterList>
  {:else}
    {#if $user_storefronts.length === 0}
      <div class="body">
        <h2>
          Create a sharable font preview page with your selected fonts<br>
          <span>Help your customers choose by seeing your fonts with their text</span>
        </h2>
        <p>
          This feature is for businesses selling customizable text on products like apparel, cards, or stickers.<br>
          Create a Storefront, add fonts, and share the link or place it on your checkout page.<br>
          Let your customers preview their text in your fonts right before ordering.
        </p>
        {#if $can_upgrade_from_pro_to_business}
          <BusinessUpsellNotice in_page={true} on:create_storefront={openNewStorefrontModal}/>
        {:else if $business_subscription_deactivated}
          <div class="button-group">
            <Button kind="accent-orange" on_fill={true} on:click={openSubscribeModal}>
              {$_('buttons.subscribeTo')} <b>{$_('app.businessName')}</b>
            </Button>
          </div>
        {:else}
        <div class="button-group"></div>
          <Button on:click={openNewStorefrontModal}>Create new storefront</Button>
        {/if}
      </div>
      <EmptyStateFooterList>
        <li><small>You can create multiple Storefronts for different projects or clients</small></li>
        <li><small>You can add a custom message and rename fonts.</small></li>
        <li><small><a href="/help/storefronts/" target="_blank">Learn more about storefronts</a> in our help pages</small></li>
      </EmptyStateFooterList>
    {/if}
  {/if}
</div>

<style>
  .StorefrontsEmptyState {
    min-height: calc(100vh - 16rem);
  }
  .body {
    padding: 3rem 2rem 3.5rem;
  }
  .body h2 {
    font-size: 2.2rem;
    margin-bottom: 2.5rem;
  }
  .body p {
    margin-top: 3rem;
  }
  .body h2 span {
    color: var(--c-text);
  }

  .button-group {
    display: flex;
    align-items: center;
    gap: 1.5rem;
    margin-top: 3.5rem;
  }
</style>
